import { MoreOutlined } from "@ant-design/icons";
import { Button, InputNumber } from "antd";
import styled from "styled-components";

export const StyledProductRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};

    &:first-child {
        padding-top: 0px;
    }

    &:last-child {
        padding-bottom: 0px;
        border-bottom: none;
    }
`;

export const StyledMoreOutlined = styled(MoreOutlined)`
    cursor: pointer;
    color: ${(props) => props.theme.secondaryTypographyColor};
    font-size: 24px;
`;

export const StyledRowBottom = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr;
    align-items: center;
`;

export const StyledODNumberInput = styled(InputNumber)<{
    isError: boolean;
}>`
    max-width: 65px;
    min-width: 65px;
    background-color: ${(props) =>
        props.isError
            ? "rgba(191, 46, 45, 0.3) !important"
            : props.theme.collapseHeaderBackground};
    border-color: ${(props) =>
        props.isError
            ? `${props.theme.dangerTypographyColor} !important`
            : props.theme.secondaryBorderColor};
    input {
        text-align: center !important;
    }
    touch-action: manipulation;
`;

export const StyledBarcodeButton = styled(Button)`
    --ant-control-height-sm: 20px;
    padding: 0;
    border-bottom: 1px dashed ${(props) => props.theme.shelfValueColor};
`;
